import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Icon } from "@material-ui/core";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Snack from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import GridItem from "../Grid/GridItem";
import GridContainer from "../Grid/GridContainer";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import styles from "../../assets/jss/material-dashboard-react/components/snackbarContentStyle.js";
import { clearSnackbar } from "../../store/modules/snackbar/index";

const useStyles = makeStyles(styles);

export default function Snackbar() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { successSnackbarMessage, successSnackbarOpen } = useSelector(
    (state) => state.snackbarReducer
  );

  function handleClose() {
    dispatch(clearSnackbar());
  }
  var action = [];
  const messageClasses = classNames({
    [classes.iconMessage]: successSnackbarMessage !== undefined,
  });
  action = [
    <IconButton
      className={classes.iconButton}
      key="close"
      aria-label="Close"
      color="inherit"
      onClick={handleClose}
    >
      <Close className={classes.close} />
    </IconButton>,
  ];

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Snack
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={successSnackbarOpen}
          onClose={handleClose}
          autoHideDuration={4000}
          message={
            <div>
              <Icon className={classes.icon}>check_circle</Icon>{" "}
              <span className={messageClasses}>{successSnackbarMessage}</span>
            </div>
          }
          action={action}
          ContentProps={{
            classes: {
              root: classes.root + " " + classes["success"],
              message: classes.message,
            },
          }}
        />
      </GridItem>
    </GridContainer>
  );
}
